// frontend/src/hooks/tankPhotoKeys.ts
/**
 * React Query keys for a tank's tank shots (tank shots plan, section 4).
 * Invalidating `all(tankId)` refreshes the list, the index and single shots;
 * assign, restore, edit, delete, cover and tank uploads do that, together
 * with the tanks list (its covers and shot counts).
 */
export const tankPhotoKeys = {
  all: (tankId: string) => ['tank-photos', tankId] as const,
  list: (tankId: string) => ['tank-photos', tankId, 'list'] as const,
  index: (tankId: string) => ['tank-photos', tankId, 'index'] as const,
  one: (tankId: string, id: number) => ['tank-photos', tankId, 'one', id] as const,
};
